import React from "react";

const CaseStudyDetailCard = ({ title, description, imageURL }) => {
  return (
    <section>
      <div className="flex flex-col items-start justify-start text-start md:w-[90%] px-4 md:px-32 pb-14 md:pb-32 space-y-4">
        <h1 className="w-[80%] md:w-full font-medium text-[32px] md:text-[48px] leading-[140%] tracking-[0%] text-[#AFAFAF]">
          {title}
        </h1>
        <p className="font-normal text-sm md:text-[20px] leading-[145%] tracking-[0%]">
          {description}
        </p>
      </div>
      <div className="md:px-[8%]">
        <div
          className={`relative overflow-hidden text-white aspect-[3/2] md:h-auto md:aspect-[4/2] min-w-full flex flex-row`}
        >
          <img
            src={imageURL}
            alt="AI Strategy"
            className="w-full h-full object-cover absolute object-center grayscale"
          />
          {/* Top Shadow */}
          <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-app-background to-transparent z-10" />

          {/* Bottom Shadow */}
          <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-app-background to-transparent z-10" />

          {/* Left Shadow */}
          <div className="absolute top-0 left-0 h-full w-32 bg-gradient-to-r from-app-background to-transparent z-10" />

          {/* Right Shadow */}
          <div className="absolute top-0 right-0 h-full w-32 bg-gradient-to-l from-app-background to-transparent z-10" />
        </div>
      </div>
    </section>
  );
};

export default CaseStudyDetailCard;
